import React from 'react';
import { MachineStatus } from './StatusBadge';
interface MachineStatusIndicatorProps {
  status: MachineStatus;
  showLabel?: boolean;
  className?: string;
}
export function MachineStatusIndicator({
  status,
  showLabel = true,
  className = ''
}: MachineStatusIndicatorProps) {
  const getDotColor = () => {
    switch (status) {
      case 'Connesso':
        return 'bg-status-success';
      case 'Disconnesso':
        return 'bg-text-tertiary';
      case 'Errore':
        return 'bg-status-error';
      case 'Non in funzione':
        return 'bg-red-600';
      case 'Manutenzione':
        return 'bg-status-warning';
      case 'Test':
        return 'bg-status-info';
      default:
        return 'bg-text-tertiary';
    }
  };
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-210">
      <div className="relative flex h-3 w-3 items-center justify-center" data-id="element-211">
        {status === 'Connesso' && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-status-success opacity-40" data-id="element-212"></span>}
        {status === 'Non in funzione' && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-600 opacity-40" data-id="element-213"></span>}
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${getDotColor()}`} data-id="element-214"></span>
      </div>
      {showLabel && <span className={`text-small font-medium ${status === 'Non in funzione' ? 'text-red-600' : 'text-text-secondary'}`} data-id="element-215">
          {status}
        </span>}
    </div>;
}